import React, { useEffect, useState } from "react";
import { ShowMarketGet } from "../../Api/Services";
import Zero from "../../assets/Icon/Zero.png";
import up from "../../assets/Icon/icons8-up-40.png";
import down from "../../assets/Icon/icons8-down-40.png";
import StateToggle from "../../Component/StateToggle/StateToggle";
import InputCus from "../../Component/InputCus/Text/InputCus";
import { CheckIdentity } from "../../Common/ConvertIdentity";

function CompetitorPrice() {
  const [isLoading, setLoading] = useState(true);
  const [Data, SetData] = useState();
  const [Competitor, SetCompetitor] = useState([]);
  const [Package, SetPackage] = useState([]);
  const [mode, setMode] = useState("Details");
  const [Product, setProduct] = useState("");

  const jalaali = require("jalaali-js");

  const start = async () => {
    try {
      const ShowMarketGetData = await ShowMarketGet();
      if (ShowMarketGetData.status && ShowMarketGetData.status === 200) {
        SetData(ShowMarketGetData.data.data);
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    start();
  }, []);

  const groupProducts = (products) => {
    const groups = {};

    products
      .filter((itemPro) => {
        const productFilter = Product?.toUpperCase?.() || "";
        const Pro = [
          itemPro.productBerandName != " " && itemPro.productBerandName + " ",

          itemPro.productTypeName != " " && itemPro.productTypeName + " ",

          itemPro.productSeriesName != " " && itemPro.productSeriesName,

          itemPro.symbol,

          itemPro.productSeriesEndName != " "
            ? itemPro.productSeriesEndName + " "
            : " ",

          itemPro.productRamName != " " && itemPro.productRamName + "/",

          itemPro.productRomName != " " && itemPro.productRomName + " ",

          itemPro.productNetworkName != " " && itemPro.productNetworkName + " ",

          itemPro.productCountryName != " " && itemPro.productCountryName + " ",

          itemPro.isInsurance && "بیمه",
        ]
          .filter(Boolean)
          .join("")
          .toUpperCase();
        return Pro.includes(productFilter);
      })
      .forEach((p) => {
        const key = [
          p.productBerandId,
          p.productTypeId,
          p.productSeriesId,
          p.symbol,
          p.productSeriesEndId,
          p.productRamId,
          p.productRomId,
          p.productNetworkId,
          p.productCountryId,
          p.isInsurance,
        ].join("-");

        if (!groups[key]) {
          groups[key] = [];
        }
        groups[key].push(p);
      });
    return Object.values(groups);
  };

  const ChangeActive = (id) => {
    let copy = [...Competitor];
    const exists = copy.includes(id);

    if (exists) {
      copy = copy.filter((item) => item !== id);
    } else {
      copy.push(id);
    }

    SetCompetitor(copy);
  };

  const ChangeActivePackage = (id) => {
    let copy = [...Package];
    const exists = copy.includes(id);

    if (exists) {
      copy = copy.filter((item) => item !== id);
    } else {
      copy.push(id);
    }

    SetPackage(copy);
  };

  const ShowMorePrice = (w) => {
    const filtered = w.filter((item, index, arr) => {
      if (index === 0) return true;
      return item.price !== arr[index - 1].price;
    });

    return (
      <div className="d-flex flex-column">
        {filtered.map((item, index) => (
          <span key={index}>
            {item.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
          </span>
        ))}
      </div>
    );
  };

  return (
    <div>
      {isLoading && (
        <div className="d-flex justify-content-center align-items-center">
          <div className="lds-facebook">
            <div />
            <div />
            <div />
          </div>
        </div>
      )}
      <div className={isLoading ? "startLoading" : "stateLoading"}>
        <div className="aaa d-flex justify-content-start align-items-start flex-column element">
          <div className="p-4">
            <StateToggle
              value={mode}
              onChange={setMode}
              options={[
                { id: "Details", label: "کامل", subtitle: "به تفکیک رنگ" },
                { id: "Avrage", label: "میانگین", subtitle: "میانگین رنگ" },
                {
                  id: "MinMax",
                  label: "Min And Max",
                  subtitle: "بالاترین و پایین ترین",
                },
                CheckIdentity("Min") && {
                  id: "Min",
                  label: "Min",
                  subtitle: "کف قیمت",
                },
              ]}
            />
          </div>
          {mode != "Min" && (
            <div className="d-flex flex-column">
              {Data?.allCategory
                .filter((w) => w.competitorCategoryCompetitors.length > 0)
                .map((itemCategory) => (
                  <div className="d-flex align-item-center border rounded m-2 p-2 bg-info">
                    <div className="d-flex align-items-center">
                      <span> {itemCategory.competitorCategoryName}</span>
                    </div>
                    <div className="d-flex justify-align-center align-item-center flex-wrap">
                      {itemCategory.competitorCategoryCompetitors.map(
                        (item) => (
                          ////////////////////////////////////////
                          <div className="tooltip-container">
                            <div
                              className={`border rounded m-2 p-2 pointer ${
                                Competitor.includes(item.id)
                                  ? "Actice"
                                  : "DeActice"
                              }`}
                              onClick={() => {
                                ChangeActive(item.id);
                              }}
                            >
                              {item.name}
                            </div>
                            {item.description && (
                              <div
                                className="tooltip-box p-3"
                                dangerouslySetInnerHTML={{
                                  __html: item.description,
                                }}
                              />
                            )}
                          </div>
                          //////////////////////////////
                        ),
                      )}
                    </div>
                  </div>
                ))}
              {Data?.allPackage.length > 0 && (
                <div className="d-flex align-item-center border rounded m-2 p-2 bg-info">
                  <div className="d-flex align-items-center">
                    <span> سبد</span>
                  </div>
                  <div className="d-flex justify-align-center align-item-center flex-wrap">
                    {Data.allPackage.map((item) => (
                      <div
                        className={`border rounded m-2 p-2 pointer ${
                          Package.includes(item.id) ? "Actice" : "DeActice"
                        }`}
                        onClick={() => {
                          ChangeActivePackage(item.id);
                        }}
                      >
                        {item.competitorName}
                        {item.title != "" && "(" + item.title + ")"}
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          )}
          <div className="d-flex">
            <InputCus
              className="m-2"
              type="text"
              name="name"
              id="name"
              text="نام"
              value={Product}
              onChange={(e) => {
                setProduct(e.target.value);
              }}
            />
          </div>
          {mode == "Details" && Data && (
            <div className="d-flex justify-content-center align-items-center aaa tableC">
              <table
                className="table tableMore aaa"
                style={{ lineHeight: "normal" }}
              >
                <thead className="sticky-header">
                  <tr className="trTable">
                    <th rowSpan={2}>سیمبل کالای</th>
                    <th rowSpan={2}>رنگ</th>
                    {Data.allCategory.map((item, key) => (
                      <React.Fragment key={key}>
                        <th
                          colSpan={
                            item.competitorCategoryCompetitors.filter((w) =>
                              Competitor.includes(w.id),
                            ).length + 1
                          }
                          className={`${item.competitorCategoryColor}`}
                        >
                          {item.competitorCategoryName}
                        </th>
                      </React.Fragment>
                    ))}
                    {Data.allPackage.length > 0 && (
                      <th colSpan={Package.length + 1}>سبد</th>
                    )}
                  </tr>
                  <tr>
                    {Data.allCategory.map((itemCategory, key) => (
                      <React.Fragment key={key}>
                        <th
                          className={`${itemCategory.competitorCategoryColor}`}
                        >
                          میانگین
                        </th>
                        {itemCategory.competitorCategoryCompetitors
                          .filter((w) => Competitor.includes(w.id))
                          .map((item) => (
                            <th
                              className={`${itemCategory.competitorCategoryColor} border border-1 border-black`}
                              key={item.id}
                            >
                              <div className="tooltip-container">
                                <span className="tooltip-target">
                                  {item.name}
                                </span>
                                <div className="tooltip-box p-3">
                                  <span>
                                    {item.createdDate &&
                                      (() => {
                                        const date = new Date(
                                          item.createdDate.replace("T", " "),
                                        );
                                        const jalaaliDate =
                                          jalaali.toJalaali(date);
                                        const year = jalaaliDate.jy;
                                        const month = jalaaliDate.jm
                                          .toString()
                                          .padStart(2, "0");
                                        const day = jalaaliDate.jd
                                          .toString()
                                          .padStart(2, "0");
                                        const hours = date
                                          .getHours()
                                          .toString()
                                          .padStart(2, "0");
                                        const minutes = date
                                          .getMinutes()
                                          .toString()
                                          .padStart(2, "0");
                                        const seconds = date
                                          .getSeconds()
                                          .toString()
                                          .padStart(2, "0");

                                        return `${year}/${month}/${day} ${hours}:${minutes}:${seconds} `;
                                      })()}
                                  </span>
                                  <br></br>
                                  <span>{item.idAuto}</span>
                                </div>
                              </div>
                            </th>
                          ))}
                      </React.Fragment>
                    ))}
                    {Data.allPackage.length > 0 && (
                      <React.Fragment>
                        <th>میانگین</th>
                        {Data.allPackage
                          .filter((w) => Package.includes(w.id))
                          .map((item) => (
                            <th
                              className={`border border-1 border-black`}
                              key={item.id}
                            >
                              <div className="tooltip-container">
                                <span className="tooltip-target">
                                  {item.competitorName}
                                  {item.title != "" && "(" + item.title + ")"}
                                </span>
                                <div className="tooltip-box p-3">
                                  <span>
                                    {item.description != "" && item.description}
                                  </span>
                                  {item.description != "" && <br />}
                                  <span>
                                    {item.createdDate &&
                                      (() => {
                                        const date = new Date(
                                          item.createdDate.replace("T", " "),
                                        );
                                        const jalaaliDate =
                                          jalaali.toJalaali(date);
                                        const year = jalaaliDate.jy;
                                        const month = jalaaliDate.jm
                                          .toString()
                                          .padStart(2, "0");
                                        const day = jalaaliDate.jd
                                          .toString()
                                          .padStart(2, "0");
                                        const hours = date
                                          .getHours()
                                          .toString()
                                          .padStart(2, "0");
                                        const minutes = date
                                          .getMinutes()
                                          .toString()
                                          .padStart(2, "0");
                                        const seconds = date
                                          .getSeconds()
                                          .toString()
                                          .padStart(2, "0");

                                        return `${year}/${month}/${day} ${hours}:${minutes}:${seconds} `;
                                      })()}
                                  </span>
                                  <br></br>
                                  <span>{item.idAuto}</span>
                                </div>
                              </div>
                            </th>
                          ))}
                      </React.Fragment>
                    )}
                  </tr>
                </thead>
                {groupProducts(Data.getBaseData).map((group, gIndex) => (
                  <tbody key={gIndex} style={{ border: "2px solid black" }}>
                    {group.map((itemPro, rowIndex) => (
                      <tr key={itemPro.id}>
                        {rowIndex === 0 && (
                          <td className="sticky-col" rowSpan={group.length}>
                            {itemPro.productBerandName != " " &&
                              itemPro.productBerandName + " "}
                            {itemPro.productTypeName != " " &&
                              itemPro.productTypeName + " "}
                            {itemPro.productSeriesName != " " &&
                              itemPro.productSeriesName}
                            {itemPro.symbol}
                            {itemPro.productSeriesEndName != " "
                              ? itemPro.productSeriesEndName + " "
                              : " "}
                            {itemPro.productRamName != " " &&
                              itemPro.productRamName + "/"}
                            {itemPro.productRomName != " " &&
                              itemPro.productRomName + " "}
                            {itemPro.productNetworkName != " " &&
                              itemPro.productNetworkName + " "}
                            {itemPro.productCountryName != " " &&
                              itemPro.productCountryName + " "}
                            {itemPro.isInsurance && "بیمه"}
                          </td>
                        )}
                        <td>{itemPro.productColorName}</td>

                        {Data.allCategory.map((itemCategory) => (
                          <React.Fragment
                            key={itemCategory.competitorCategoryId}
                          >
                            <td
                              className={itemCategory.competitorCategoryColor}
                            >
                              {(() => {
                                const avgPrice = itemPro.categoryAvrages.find(
                                  (w) =>
                                    w.competitorCategoryId ==
                                    itemCategory.competitorCategoryId,
                                );
                                return avgPrice
                                  ? Math.floor(avgPrice.avrage)
                                      .toString()
                                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                  : "-";
                              })()}
                            </td>

                            {itemCategory.competitorCategoryCompetitors
                              .filter((w) => Competitor.includes(w.id))
                              .map((itemCompetitore) => (
                                <td
                                  key={itemCompetitore.id}
                                  className={
                                    itemCategory.competitorCategoryColor
                                  }
                                >
                                  <div className="tooltip-container">
                                    <div className="d-flex align-item-center justify-content-around tooltip-target">
                                      {(() => {
                                        const price =
                                          itemPro.competitorPrices?.filter(
                                            (e) =>
                                              e.competitorId ===
                                              itemCompetitore.id,
                                          );
                                        return price.length == 0 ? (
                                          <span>-</span>
                                        ) : (
                                          <din className="d-flex">
                                            {(() => {
                                              let ascending = null;
                                              let Count = 0;
                                              let data = [...price];
                                              if (data.length > 1) {
                                                let lastAmount = data.shift();

                                                for (
                                                  let i = 0;
                                                  i < data.length;
                                                  i++
                                                ) {
                                                  let item = data[i];

                                                  if (
                                                    item.price ===
                                                    lastAmount.price
                                                  ) {
                                                    continue;
                                                  }

                                                  if (
                                                    item.price <
                                                    lastAmount.price
                                                  ) {
                                                    if (ascending === true) {
                                                      Count++;
                                                    } else if (
                                                      ascending === null
                                                    ) {
                                                      ascending = true;
                                                      Count = 1;
                                                    } else if (
                                                      ascending === false
                                                    ) {
                                                      break;
                                                    }
                                                  }

                                                  if (
                                                    item.price >
                                                    lastAmount.price
                                                  ) {
                                                    if (ascending === false) {
                                                      Count++;
                                                    } else if (
                                                      ascending === null
                                                    ) {
                                                      Count = 1;
                                                      ascending = false;
                                                    } else if (
                                                      ascending === true
                                                    ) {
                                                      break;
                                                    }
                                                  }

                                                  lastAmount = item;
                                                }
                                              }

                                              if (ascending == true) {
                                                return (
                                                  <>
                                                    <span className="Sabz border rounded p-1">
                                                      {Count && Count}
                                                    </span>
                                                    <img
                                                      width={"20px"}
                                                      height={"20px"}
                                                      src={up}
                                                    />
                                                    <div className="tooltip-box p-3">
                                                      {ShowMorePrice(price)}
                                                    </div>
                                                  </>
                                                );
                                              }
                                              if (ascending == false) {
                                                return (
                                                  <>
                                                    <span className="ghermez border rounded p-1">
                                                      {Count && Count}
                                                    </span>
                                                    <img
                                                      idth={"20px"}
                                                      height={"20px"}
                                                      src={down}
                                                    />
                                                    <div className="tooltip-box p-3">
                                                      {ShowMorePrice(price)}
                                                    </div>
                                                  </>
                                                );
                                              }
                                            })()}
                                            <span>
                                              {price[0].price
                                                .toString()
                                                .replace(
                                                  /\B(?=(\d{3})+(?!\d))/g,
                                                  ",",
                                                )}
                                            </span>
                                            {price[0].createdDate !=
                                              itemCompetitore.createdDate && (
                                              <>
                                                <img
                                                  width="20px"
                                                  height="20px"
                                                  src={Zero}
                                                />
                                                <div className="tooltip-box p-3">
                                                  {ShowMorePrice(price)}
                                                </div>
                                              </>
                                            )}
                                          </din>
                                        );
                                      })()}
                                    </div>
                                  </div>
                                </td>
                              ))}
                          </React.Fragment>
                        ))}
                        {Data.allPackage.length > 0 && (
                          <React.Fragment>
                            <td>
                              {(() => {
                                const average =
                                  group[0].competitorPackagePrices.reduce(
                                    (sum, item) => sum + item.price,
                                    0,
                                  ) / group[0].competitorPackagePrices.length;
                                return average
                                  ? Math.floor(average)
                                      .toString()
                                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                  : "-";
                              })()}
                            </td>

                            {Data.allPackage
                              .filter((w) => Package.includes(w.id))
                              .map((itemCompetitore) => (
                                <td key={itemCompetitore.id}>
                                  <div className="d-flex align-item-center justify-content-around">
                                    {(() => {
                                      const price =
                                        group[0]?.competitorPackagePrices?.find(
                                          (e) =>
                                            e.competitorPackageId ==
                                            itemCompetitore.id,
                                        );
                                      return price?.price ? (
                                        <span>
                                          {price.price
                                            .toString()
                                            .replace(
                                              /\B(?=(\d{3})+(?!\d))/g,
                                              ",",
                                            )}
                                        </span>
                                      ) : (
                                        <span>-</span>
                                      );
                                    })()}
                                  </div>
                                </td>
                              ))}
                          </React.Fragment>
                        )}
                      </tr>
                    ))}
                  </tbody>
                ))}
              </table>
            </div>
          )}
          {mode == "Min" && Data && (
            <div className="d-flex justify-content-center align-items-center aaa tableC">
              <table
                className="table tableMore aaa"
                style={{ lineHeight: "normal" }}
              >
                <thead className="sticky-header">
                  <tr className="trTable">
                    <th rowSpan={2}>سیمبل کالای</th>
                    <th rowSpan={2}>رنگ</th>
                    {Data.allCategory.map((item, key) => (
                      <React.Fragment key={key}>
                        <th
                          colSpan={
                            item.competitorCategoryCompetitors.length > 0
                              ? 2
                              : 1
                          }
                          className={`${item.competitorCategoryColor}`}
                        >
                          {item.competitorCategoryName}
                        </th>
                      </React.Fragment>
                    ))}
                    {Data.allPackage.length > 0 && <th colSpan={2}>سبد</th>}
                  </tr>
                  <tr>
                    {Data.allCategory.map((itemCategory, key) => (
                      <React.Fragment key={key}>
                        <th
                          className={`${itemCategory.competitorCategoryColor}`}
                        >
                          میانگین
                        </th>
                        {itemCategory.competitorCategoryCompetitors.length >
                          0 && (
                          <th
                            className={`${itemCategory.competitorCategoryColor}`}
                          >
                            کف
                          </th>
                        )}
                      </React.Fragment>
                    ))}
                    {Data.allPackage.length > 0 && (
                      <React.Fragment>
                        <th>میانگین</th>
                        <th>کف</th>
                      </React.Fragment>
                    )}
                  </tr>
                </thead>
                {groupProducts(Data.getBaseData).map((group, gIndex) => (
                  <tbody key={gIndex} style={{ border: "2px solid black" }}>
                    {group.map((itemPro, rowIndex) => (
                      <tr key={itemPro.id}>
                        {rowIndex === 0 && (
                          <td className="sticky-col" rowSpan={group.length}>
                            {itemPro.productBerandName != " " &&
                              itemPro.productBerandName + " "}
                            {itemPro.productTypeName != " " &&
                              itemPro.productTypeName + " "}
                            {itemPro.productSeriesName != " " &&
                              itemPro.productSeriesName}
                            {itemPro.symbol}
                            {itemPro.productSeriesEndName != " "
                              ? itemPro.productSeriesEndName + " "
                              : " "}
                            {itemPro.productRamName != " " &&
                              itemPro.productRamName + "/"}
                            {itemPro.productRomName != " " &&
                              itemPro.productRomName + " "}
                            {itemPro.productNetworkName != " " &&
                              itemPro.productNetworkName + " "}
                            {itemPro.productCountryName != " " &&
                              itemPro.productCountryName + " "}
                            {itemPro.isInsurance && "بیمه"}
                          </td>
                        )}
                        <td>{itemPro.productColorName}</td>

                        {Data.allCategory.map((itemCategory) => (
                          <React.Fragment
                            key={itemCategory.competitorCategoryId}
                          >
                            <td
                              className={itemCategory.competitorCategoryColor}
                            >
                              {(() => {
                                const avgPrice = itemPro.categoryAvrages.find(
                                  (w) =>
                                    w.competitorCategoryId ==
                                    itemCategory.competitorCategoryId,
                                );
                                return avgPrice
                                  ? Math.floor(avgPrice.avrage)
                                      .toString()
                                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                  : "-";
                              })()}
                            </td>

                            {itemCategory.competitorCategoryCompetitors.length >
                              0 && (
                              <td
                                className={itemCategory.competitorCategoryColor}
                              >
                                {(() => {
                                  const avgPrice = itemPro.categoryAvrages.find(
                                    (w) =>
                                      w.competitorCategoryId ==
                                      itemCategory.competitorCategoryId,
                                  );

                                  const competitorIds =
                                    itemCategory.competitorCategoryCompetitors.map(
                                      (r) => r.id,
                                    );

                                  const competitorPriceItems =
                                    itemPro.competitorPrices.filter((w) =>
                                      competitorIds.includes(w.competitorId),
                                    );

                                  if (competitorPriceItems.length === 0)
                                    return "-";

                                  // پیدا کردن آیتم با کمترین قیمت
                                  const minItem = competitorPriceItems.reduce(
                                    (min, curr) =>
                                      curr.price < min.price ? curr : min,
                                  );

                                  // پیدا کردن اطلاعات رقیب مربوط به همون آیتم
                                  const competitor =
                                    itemCategory.competitorCategoryCompetitors.find(
                                      (c) => c.id === minItem.competitorId,
                                    );
                                  let warning = false;
                                  if (
                                    avgPrice.avrage > 0 &&
                                    minItem.price > 0
                                  ) {
                                    const percentDrop =
                                      ((avgPrice.avrage - minItem.price) /
                                        avgPrice.avrage) *
                                      100;
                                    warning = percentDrop > 5;
                                  }

                                  return (
                                    <div
                                      className={`d-flex flex-column ${
                                        warning ? " bg-warning" : ""
                                      }`}
                                    >
                                      <span>{competitor?.name ?? "-"}</span>
                                      <span>
                                        {minItem.price
                                          .toString()
                                          .replace(
                                            /\B(?=(\d{3})+(?!\d))/g,
                                            ",",
                                          )}
                                      </span>
                                    </div>
                                  );
                                })()}
                              </td>
                            )}
                          </React.Fragment>
                        ))}
                        {Data.allPackage.length > 0 && (
                          <React.Fragment>
                            <td>
                              {(() => {
                                const average =
                                  group[0].competitorPackagePrices.reduce(
                                    (sum, item) => sum + item.price,
                                    0,
                                  ) / group[0].competitorPackagePrices.length;
                                return average
                                  ? Math.floor(average)
                                      .toString()
                                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                  : "-";
                              })()}
                            </td>
                            <td>
                              {(() => {
                                if (
                                  group[0].competitorPackagePrices.length === 0
                                )
                                  return "-";
                                const average =
                                  group[0].competitorPackagePrices.reduce(
                                    (sum, item) => sum + item.price,
                                    0,
                                  ) / group[0].competitorPackagePrices.length;

                                const minItem =
                                  group[0].competitorPackagePrices.reduce(
                                    (min, curr) =>
                                      curr.price < min.price ? curr : min,
                                  );
                                const competitorminItem = Data.allPackage.find(
                                  (w) => w.id == minItem.competitorPackageId,
                                );

                                let warning = false;

                                const percentDrop =
                                  ((average - minItem.price) / average) * 100;
                                warning = percentDrop > 5;

                                return (
                                  <div
                                    className={`d-flex flex-column ${
                                      warning ? " bg-warning" : ""
                                    }`}
                                  >
                                    <span>
                                      {competitorminItem.competitorName}
                                      {competitorminItem.title != "" &&
                                        "(" + competitorminItem.title + ")"}
                                    </span>
                                    <span>
                                      {minItem.price
                                        .toString()
                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                    </span>
                                  </div>
                                );
                              })()}
                            </td>
                          </React.Fragment>
                        )}
                      </tr>
                    ))}
                  </tbody>
                ))}
              </table>
            </div>
          )}
          {mode == "MinMax" && Data && (
            <div className="d-flex justify-content-center align-items-center aaa tableC">
              <table
                className="table tableMore aaa"
                style={{ lineHeight: "normal" }}
              >
                <thead className="sticky-header">
                  <tr className="trTable">
                    <th rowSpan={2}>سیمبل کالای</th>
                    <th rowSpan={2}>Min&Max</th>
                    {Data.allCategory.map((item, key) => (
                      <React.Fragment key={key}>
                        <th
                          colSpan={
                            item.competitorCategoryCompetitors.filter((w) =>
                              Competitor.includes(w.id),
                            ).length + 1
                          }
                          className={`${item.competitorCategoryColor}`}
                        >
                          {item.competitorCategoryName}
                        </th>
                      </React.Fragment>
                    ))}
                    {Data.allPackage.length > 0 && (
                      <React.Fragment>
                        <th
                          colSpan={
                            Data.allPackage.filter((w) =>
                              Package.includes(w.id),
                            ).length + 1
                          }
                        >
                          سبد
                        </th>
                      </React.Fragment>
                    )}
                  </tr>
                  <tr>
                    {Data.allCategory.map((itemCategory, key) => (
                      <React.Fragment key={key}>
                        <th
                          className={`${itemCategory.competitorCategoryColor}`}
                        >
                          میانگین
                        </th>
                        {itemCategory.competitorCategoryCompetitors
                          .filter((w) => Competitor.includes(w.id))
                          .map((item) => (
                            <th
                              className={`${itemCategory.competitorCategoryColor} border border-1 border-black`}
                              key={item.id}
                            >
                              <div className="tooltip-container">
                                <span className="tooltip-target">
                                  {item.name}
                                </span>
                                <div className="tooltip-box p-3">
                                  <span>
                                    {item.createdDate &&
                                      (() => {
                                        const date = new Date(
                                          item.createdDate.replace("T", " "),
                                        );
                                        const jalaaliDate =
                                          jalaali.toJalaali(date);
                                        const year = jalaaliDate.jy;
                                        const month = jalaaliDate.jm
                                          .toString()
                                          .padStart(2, "0");
                                        const day = jalaaliDate.jd
                                          .toString()
                                          .padStart(2, "0");
                                        const hours = date
                                          .getHours()
                                          .toString()
                                          .padStart(2, "0");
                                        const minutes = date
                                          .getMinutes()
                                          .toString()
                                          .padStart(2, "0");
                                        const seconds = date
                                          .getSeconds()
                                          .toString()
                                          .padStart(2, "0");

                                        return `${year}/${month}/${day} ${hours}:${minutes}:${seconds} `;
                                      })()}
                                  </span>
                                  <br></br>
                                  <span>{item.idAuto}</span>
                                </div>
                              </div>
                            </th>
                          ))}
                      </React.Fragment>
                    ))}
                    {Data.allPackage.length > 0 && (
                      <React.Fragment>
                        <th>میانگین</th>
                        {Data.allPackage
                          .filter((w) => Package.includes(w.id))
                          .map((item) => (
                            <th
                              className={`border border-1 border-black`}
                              key={item.id}
                            >
                              <div className="tooltip-container">
                                <span className="tooltip-target">
                                  {item.competitorName}
                                  {item.title != "" && "(" + item.title + ")"}
                                </span>
                                <div className="tooltip-box p-3">
                                  <span>
                                    {item.description != "" && item.description}
                                  </span>
                                  {item.description != "" && <br />}
                                  <span>
                                    {item.createdDate &&
                                      (() => {
                                        const date = new Date(
                                          item.createdDate.replace("T", " "),
                                        );
                                        const jalaaliDate =
                                          jalaali.toJalaali(date);
                                        const year = jalaaliDate.jy;
                                        const month = jalaaliDate.jm
                                          .toString()
                                          .padStart(2, "0");
                                        const day = jalaaliDate.jd
                                          .toString()
                                          .padStart(2, "0");
                                        const hours = date
                                          .getHours()
                                          .toString()
                                          .padStart(2, "0");
                                        const minutes = date
                                          .getMinutes()
                                          .toString()
                                          .padStart(2, "0");
                                        const seconds = date
                                          .getSeconds()
                                          .toString()
                                          .padStart(2, "0");

                                        return `${year}/${month}/${day} ${hours}:${minutes}:${seconds} `;
                                      })()}
                                  </span>
                                  <br></br>
                                  <span>{item.idAuto}</span>
                                </div>
                              </div>
                            </th>
                          ))}
                      </React.Fragment>
                    )}
                  </tr>
                </thead>
                {groupProducts(Data.getBaseData).map((group, gIndex) => (
                  <tbody key={gIndex} style={{ border: "2px solid black" }}>
                    <tr key={group[0].id}>
                      <td className="sticky-col" rowSpan={2}>
                        {group[0].productBerandName != " " &&
                          group[0].productBerandName + " "}
                        {group[0].productTypeName != " " &&
                          group[0].productTypeName + " "}
                        {group[0].productSeriesName != " " &&
                          group[0].productSeriesName}
                        {group[0].symbol}
                        {group[0].productSeriesEndName != " "
                          ? group[0].productSeriesEndName + " "
                          : " "}
                        {group[0].productRamName != " " &&
                          group[0].productRamName + "/"}
                        {group[0].productRomName != " " &&
                          group[0].productRomName + " "}
                        {group[0].productNetworkName != " " &&
                          group[0].productNetworkName + " "}
                        {group[0].productCountryName != " " &&
                          group[0].productCountryName + " "}
                        {group[0].isInsurance && "بیمه"}
                      </td>
                      <td>Min</td>
                      {Data.allCategory.map((itemCategory) => (
                        <React.Fragment key={itemCategory.competitorCategoryId}>
                          <td
                            className={itemCategory.competitorCategoryColor}
                            rowSpan={2}
                          >
                            {(() => {
                              const allPrices = group
                                .flatMap((item) => item.categoryAvrages)
                                .filter(
                                  (e) =>
                                    e.competitorCategoryId ==
                                    itemCategory.competitorCategoryId,
                                )
                                .map((e) => Number(e.avrage || 0));
                              const total = allPrices.reduce(
                                (sum, avrage) => sum + avrage,
                                0,
                              );
                              const avg =
                                allPrices.length > 0
                                  ? Math.floor(total / allPrices.length)
                                  : 0;
                              return avg === 0
                                ? "-"
                                : avg
                                    .toString()
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                            })()}
                          </td>

                          {itemCategory.competitorCategoryCompetitors
                            .filter((w) => Competitor.includes(w.id))
                            .map((itemCompetitore) => (
                              <td
                                key={itemCompetitore.id}
                                className={itemCategory.competitorCategoryColor}
                              >
                                <div className="d-flex align-item-center justify-content-around">
                                  {(() => {
                                    const filteredPrices = group
                                      .flatMap((item) => item.competitorPrices)
                                      .filter(
                                        (e) =>
                                          e.competitorId ===
                                            itemCompetitore.id &&
                                          e.createdDate ===
                                            itemCompetitore.createdDate,
                                      );

                                    // پیدا کردن آبجکت با کمترین قیمت
                                    let minPriceObj = null;
                                    if (filteredPrices.length > 0) {
                                      minPriceObj = filteredPrices.reduce(
                                        (min, current) =>
                                          Number(current.price) <
                                          Number(min.price)
                                            ? current
                                            : min,
                                      );
                                    }

                                    if (!minPriceObj) {
                                      return <span>-</span>;
                                    }

                                    const formattedPrice = Number(
                                      minPriceObj.price,
                                    )
                                      .toString()
                                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",");

                                    return (
                                      <span>
                                        {formattedPrice}{" "}
                                        <span
                                          style={{
                                            color: "#888",
                                            fontSize: "0.85em",
                                          }}
                                        >
                                          (
                                          {
                                            Data.getBaseData.find(
                                              (w) =>
                                                w.id == minPriceObj.productId,
                                            )?.productColorName
                                          }
                                          )
                                        </span>
                                      </span>
                                    );
                                  })()}
                                </div>
                              </td>
                            ))}
                        </React.Fragment>
                      ))}
                      {Data.allPackage.length > 0 && (
                        <React.Fragment>
                          <td rowSpan={2}>
                            {(() => {
                              const average =
                                group[0].competitorPackagePrices.reduce(
                                  (sum, item) => sum + item.price,
                                  0,
                                ) / group[0].competitorPackagePrices.length;
                              return average
                                ? Math.floor(average)
                                    .toString()
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                : "-";
                            })()}
                          </td>

                          {Data.allPackage
                            .filter((w) => Package.includes(w.id))
                            .map((itemCompetitore) => (
                              <td key={itemCompetitore.id}>
                                <div className="d-flex align-item-center justify-content-around">
                                  {(() => {
                                    const price =
                                      group[0]?.competitorPackagePrices?.find(
                                        (e) =>
                                          e.competitorPackageId ==
                                          itemCompetitore.id,
                                      );
                                    return price?.price ? (
                                      <span>
                                        {price.price
                                          .toString()
                                          .replace(
                                            /\B(?=(\d{3})+(?!\d))/g,
                                            ",",
                                          )}
                                      </span>
                                    ) : (
                                      <span>-</span>
                                    );
                                  })()}
                                </div>
                              </td>
                            ))}
                        </React.Fragment>
                      )}
                    </tr>
                    <tr key={group[0].id + 1}>
                      <td>Max</td>
                      {Data.allCategory.map((itemCategory) => (
                        <React.Fragment key={itemCategory.competitorCategoryId}>
                          {itemCategory.competitorCategoryCompetitors
                            .filter((w) => Competitor.includes(w.id))
                            .map((itemCompetitore) => (
                              <td
                                key={itemCompetitore.id}
                                className={itemCategory.competitorCategoryColor}
                              >
                                <div className="d-flex align-item-center justify-content-around">
                                  {(() => {
                                    const filteredPrices = group
                                      .flatMap((item) => item.competitorPrices)
                                      .filter(
                                        (e) =>
                                          e.competitorId ===
                                            itemCompetitore.id &&
                                          e.createdDate ===
                                            itemCompetitore.createdDate,
                                      );

                                    // پیدا کردن آبجکت با کمترین قیمت
                                    let maxPriceObj = null;
                                    if (filteredPrices.length > 0) {
                                      maxPriceObj = filteredPrices.reduce(
                                        (max, current) =>
                                          Number(current.price) >
                                          Number(max.price)
                                            ? current
                                            : max,
                                      );
                                    }

                                    if (!maxPriceObj) {
                                      return <span>-</span>;
                                    }

                                    const formattedPrice = Number(
                                      maxPriceObj.price,
                                    )
                                      .toString()
                                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",");

                                    return (
                                      <span>
                                        {formattedPrice}
                                        <span
                                          style={{
                                            color: "#888",
                                            fontSize: "0.85em",
                                          }}
                                        >
                                          (
                                          {
                                            Data.getBaseData.find(
                                              (w) =>
                                                w.id == maxPriceObj.productId,
                                            )?.productColorName
                                          }
                                          )
                                        </span>
                                      </span>
                                    );
                                  })()}
                                </div>
                              </td>
                            ))}
                        </React.Fragment>
                      ))}
                      {Data.allPackage.length > 0 && (
                        <React.Fragment>
                          {Data.allPackage
                            .filter((w) => Package.includes(w.id))
                            .map((itemCompetitore) => (
                              <td>
                                <div className="d-flex align-item-center justify-content-around">
                                  {(() => {
                                    const price =
                                      group[0]?.competitorPackagePrices?.find(
                                        (e) =>
                                          e.competitorPackageId ==
                                          itemCompetitore.id,
                                      );
                                    return price?.price ? (
                                      <span>
                                        {price.price
                                          .toString()
                                          .replace(
                                            /\B(?=(\d{3})+(?!\d))/g,
                                            ",",
                                          )}
                                      </span>
                                    ) : (
                                      <span>-</span>
                                    );
                                  })()}
                                </div>
                              </td>
                            ))}
                        </React.Fragment>
                      )}
                    </tr>
                  </tbody>
                ))}
              </table>
            </div>
          )}
          {mode == "Avrage" && Data && (
            <div className="d-flex justify-content-center align-items-center aaa tableC">
              <table
                className="table tableMore aaa"
                style={{ lineHeight: "normal" }}
              >
                <thead className="sticky-header">
                  <tr className="trTable">
                    <th rowSpan={2}>سیمبل کالای</th>
                    {Data.allCategory.map((item, key) => (
                      <React.Fragment key={key}>
                        <th
                          colSpan={
                            item.competitorCategoryCompetitors.filter((w) =>
                              Competitor.includes(w.id),
                            ).length + 1
                          }
                          className={`${item.competitorCategoryColor}`}
                        >
                          {item.competitorCategoryName}
                        </th>
                      </React.Fragment>
                    ))}
                    {Data.allPackage.length > 0 && (
                      <React.Fragment>
                        <th colSpan={Data.allPackage.length + 1}>سبد</th>
                      </React.Fragment>
                    )}
                  </tr>
                  <tr>
                    {Data.allCategory.map((itemCategory, key) => (
                      <React.Fragment key={key}>
                        <th
                          className={`${itemCategory.competitorCategoryColor}`}
                        >
                          میانگین
                        </th>
                        {itemCategory.competitorCategoryCompetitors
                          .filter((w) => Competitor.includes(w.id))
                          .map((item) => (
                            <th
                              className={`${itemCategory.competitorCategoryColor} border border-1 border-black`}
                              key={item.id}
                            >
                              <div className="tooltip-container">
                                <span className="tooltip-target">
                                  {item.name}
                                </span>
                                <div className="tooltip-box p-3">
                                  <span>
                                    {item.createdDate &&
                                      (() => {
                                        const date = new Date(
                                          item.createdDate.replace("T", " "),
                                        );
                                        const jalaaliDate =
                                          jalaali.toJalaali(date);
                                        const year = jalaaliDate.jy;
                                        const month = jalaaliDate.jm
                                          .toString()
                                          .padStart(2, "0");
                                        const day = jalaaliDate.jd
                                          .toString()
                                          .padStart(2, "0");
                                        const hours = date
                                          .getHours()
                                          .toString()
                                          .padStart(2, "0");
                                        const minutes = date
                                          .getMinutes()
                                          .toString()
                                          .padStart(2, "0");
                                        const seconds = date
                                          .getSeconds()
                                          .toString()
                                          .padStart(2, "0");

                                        return `${year}/${month}/${day} ${hours}:${minutes}:${seconds} `;
                                      })()}
                                  </span>
                                  <br></br>
                                </div>
                              </div>
                            </th>
                          ))}
                      </React.Fragment>
                    ))}
                    {Data.allPackage.length > 0 && (
                      <React.Fragment>
                        <th>میانگین</th>
                        {Data.allPackage
                          .filter((w) => Package.includes(w.id))
                          .map((item) => (
                            <th>
                              <div className="tooltip-container">
                                <span className="tooltip-target">
                                  {item.competitorName}
                                  {item.title != "" && "(" + item.title + ")"}
                                </span>
                                <div className="tooltip-box p-3">
                                  <span>
                                    {item.description != "" && item.description}
                                  </span>
                                  {item.description != "" && <br />}
                                  <span>
                                    {item.createdDate &&
                                      (() => {
                                        const date = new Date(
                                          item.createdDate.replace("T", " "),
                                        );
                                        const jalaaliDate =
                                          jalaali.toJalaali(date);
                                        const year = jalaaliDate.jy;
                                        const month = jalaaliDate.jm
                                          .toString()
                                          .padStart(2, "0");
                                        const day = jalaaliDate.jd
                                          .toString()
                                          .padStart(2, "0");
                                        const hours = date
                                          .getHours()
                                          .toString()
                                          .padStart(2, "0");
                                        const minutes = date
                                          .getMinutes()
                                          .toString()
                                          .padStart(2, "0");
                                        const seconds = date
                                          .getSeconds()
                                          .toString()
                                          .padStart(2, "0");

                                        return `${year}/${month}/${day} ${hours}:${minutes}:${seconds} `;
                                      })()}
                                  </span>
                                  <br></br>
                                </div>
                              </div>
                            </th>
                          ))}
                      </React.Fragment>
                    )}
                  </tr>
                </thead>
                {groupProducts(Data.getBaseData).map((group, gIndex) => (
                  <tbody key={gIndex} style={{ border: "2px solid black" }}>
                    <tr key={group[0].id}>
                      <td className="sticky-col">
                        {group[0].productBerandName != " " &&
                          group[0].productBerandName + " "}
                        {group[0].productTypeName != " " &&
                          group[0].productTypeName + " "}
                        {group[0].productSeriesName != " " &&
                          group[0].productSeriesName}
                        {group[0].symbol}
                        {group[0].productSeriesEndName != " "
                          ? group[0].productSeriesEndName + " "
                          : " "}
                        {group[0].productRamName != " " &&
                          group[0].productRamName + "/"}
                        {group[0].productRomName != " " &&
                          group[0].productRomName + " "}
                        {group[0].productNetworkName != " " &&
                          group[0].productNetworkName + " "}
                        {group[0].productCountryName != " " &&
                          group[0].productCountryName + " "}
                        {group[0].isInsurance && "بیمه"}
                      </td>

                      {Data.allCategory.map((itemCategory) => (
                        <React.Fragment key={itemCategory.competitorCategoryId}>
                          <td className={itemCategory.competitorCategoryColor}>
                            {(() => {
                              const allPrices = group
                                .flatMap((item) => item.categoryAvrages)
                                .filter(
                                  (e) =>
                                    e.competitorCategoryId ==
                                    itemCategory.competitorCategoryId,
                                )
                                .map((e) => Number(e.avrage || 0));
                              const total = allPrices.reduce(
                                (sum, avrage) => sum + avrage,
                                0,
                              );
                              const avg =
                                allPrices.length > 0
                                  ? Math.floor(total / allPrices.length)
                                  : 0;
                              return avg === 0
                                ? "-"
                                : avg
                                    .toString()
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                            })()}
                          </td>

                          {itemCategory.competitorCategoryCompetitors
                            .filter((w) => Competitor.includes(w.id))
                            .map((itemCompetitore) => (
                              <td
                                key={itemCompetitore.id}
                                className={itemCategory.competitorCategoryColor}
                              >
                                <div className="d-flex align-item-center justify-content-around">
                                  {(() => {
                                    const allPrices = group
                                      .flatMap((item) => item.competitorPrices)
                                      .filter(
                                        (e) =>
                                          e.competitorId ==
                                            itemCompetitore.id &&
                                          e.createdDate ==
                                            itemCompetitore.createdDate,
                                      )
                                      .map((e) => Number(e.price || 0));
                                    const total = allPrices.reduce(
                                      (sum, price) => sum + price,
                                      0,
                                    );
                                    const avg =
                                      allPrices.length > 0
                                        ? Math.floor(total / allPrices.length)
                                        : 0;
                                    return avg == 0 ? (
                                      <span>-</span>
                                    ) : (
                                      <din className="d-flex">
                                        <span>
                                          {avg
                                            .toString()
                                            .replace(
                                              /\B(?=(\d{3})+(?!\d))/g,
                                              ",",
                                            )}
                                        </span>
                                      </din>
                                    );
                                  })()}
                                </div>
                              </td>
                            ))}
                        </React.Fragment>
                      ))}
                      {Data.allPackage.length > 0 && (
                        <React.Fragment>
                          <td>
                            {(() => {
                              const average =
                                group[0].competitorPackagePrices.reduce(
                                  (sum, item) => sum + item.price,
                                  0,
                                ) / group[0].competitorPackagePrices.length;
                              return average
                                ? Math.floor(average)
                                    .toString()
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                : "-";
                            })()}
                          </td>

                          {Data.allPackage
                            .filter((w) => Package.includes(w.id))
                            .map((itemCompetitore) => (
                              <td>
                                <div className="d-flex align-item-center justify-content-around">
                                  {(() => {
                                    const price =
                                      group[0]?.competitorPackagePrices?.find(
                                        (e) =>
                                          e.competitorPackageId ==
                                          itemCompetitore.id,
                                      );
                                    return price?.price ? (
                                      <span>
                                        {price.price
                                          .toString()
                                          .replace(
                                            /\B(?=(\d{3})+(?!\d))/g,
                                            ",",
                                          )}
                                      </span>
                                    ) : (
                                      <span>-</span>
                                    );
                                  })()}
                                </div>
                              </td>
                            ))}
                        </React.Fragment>
                      )}
                    </tr>
                  </tbody>
                ))}
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default CompetitorPrice;
